import React from "react";
import { Table } from "antd";


function FailedPaymentsTable(props) {
  const columns = [
    {
      title: "From",
      width: "20%",
      sorter: { compare: (a, b) => a.sendingAccount.localeCompare(b.sendingAccount) },
      render: (_, record) => <span>{record.sendingAccount}</span>,
    },
    {
      title: "To",
      width: "20%",
      sorter: { compare: (a, b) => a.receivingAccount.localeCompare(b.receivingAccount) },
      render: (_, record) => <span>{record.receivingAccount}</span>,
    },
    {
      title: "Method",
      width: "40%",
      sorter: { compare: (a, b) => a.type.localeCompare(b.type) },
      render: (_, record) => <span>{record.type}</span>,
    },
    {
      title: "Amount",
      align: "right",
      width: "20%",
      render: (_, record) => <span>{`$${parseFloat(record.amount).toFixed(2)}`}</span>
    },
  ];

  return (
    <Table
      pagination={{ defaultPageSize: 50, showSizeChanger: true }}
      columns={columns}
      bordered
      dataSource={props.paymentsData}
      tableLayout="fixed"
    />
  );
}

export default FailedPaymentsTable;